module.exports = __webpack_public_path__ + "assets/c613236f25fc18b276d8b6778875a7ad.svg";